export default __webpack_public_path__ + "static/media/BootcampMobile.00eb5342.png";